import { createSlice } from '@reduxjs/toolkit';

export const popupCenterSlice = createSlice({
  name: 'popupCenter',
  initialState: {
    isOpen: false,
    component: null,
    isClosable: true,
    closingFunction: null,
  },
  reducers: {
    setPopupCenterOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    setPopupCenterComponentRender: (state, action) => {
      state.component = action.payload;
    },
    setPopupCenterClosable: (state, action) => {
      state.isClosable = action.payload;
    },
    setPopupCenterClosingFunction: (state, action) => {
      state.closingFunction = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setPopupCenterOpen, setPopupCenterComponentRender, setPopupCenterClosable, setPopupCenterClosingFunction } = popupCenterSlice.actions;

export default popupCenterSlice.reducer;
